<template lang="html">
  <div class="custom__select center w-full">
    <VsSelect
      ref="selectBox"
      :typeable="autocomplete"
      :disabled="disabled"
      @clearValue="clearVal"
      @input-change="inputChanged"
      class="w-full"
      :placeholder="placeholder"
      v-model="inputVal"
      @scrollEnd="handleScrollEnd"
      :loader="processing || loading"
      :clearable="clearable"
      :multiple="multiple"
    >
      <vs-select-item v-if="newLabel" :text="newLabel" value="newItemAddEvent" class="select-head-btn" />
      <vs-select-item
        v-for="(item, i) in vOptions"
        :key="i"
        :label="formatUserSelectLabel(item)"
        :text="getSelectItemText(item)"
        :value="item[val] || item['value']"
        class="select-item-with-avatar"
      >
        {{ item[val] || item['value'] }}
      </vs-select-item>
    </VsSelect>
  </div>
</template>

<script>
import VsSelect from '@/components/custom/form-elements/CustomSelect.vue'
import VsSelectItem from '@/components/custom/form-elements/vsSelectItem.vue'

export default {
  name: 'Select2',

  components: {
    VsSelect,
    VsSelectItem
  },

  props: {
    ssr: {
      type: Boolean,
      default: false
    },
    selectName: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    extra: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    val: {
      type: String,
      default: '_id'
    },
    action: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    newLabel: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: Boolean,
      default: true
    },
    searchFromStart: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    viewRendered: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      limit: 5,
      page: 1,
      search: null,
      total: 0,
      sso: [],
      processing: false,
      type: 'dropdown',
      nodata: false
    }
  },

  async mounted() {
    this.sso = []
    await this.getOptions()
  },

  computed: {
    inputVal: {
      get() {
        if (this.multiple) {
          const filteredArray = this.vOptions
            .filter((value) => this.value.includes(value[this.val] || value['value']))
            .reduce((acc, item) => {
              acc.push(item[this.val] || item['value'])

              return acc
            }, [])

          return filteredArray
        } else {
          const option = this.vOptions.find((item) => (item[this.val] || item['value']) === this.value)
          const selected = option || (this.value && (this.value.label || this.value.handle_name) ? this.value : null)
          return this.formatUserSelectLabel(selected)
        }
      },
      set(val) {
        if (val === 'newItemAddEvent') {
          this.$emit('addNew')
        } else {
          this.$emit('input', { ...this.vOptions.find((item) => val === (item[this.val] || item['value'])), value: val })
        }
      }
    },

    vOptions() {
      let options = [...this.extra, ...this.options, ...this.sso]
      if (this.autocomplete && this.searchFromStart) {
        options = options.filter((e) => {
          return !this.search || (e.label || '').toLowerCase().startsWith(this.search.toLowerCase())
          // return this.search ? (e.label || '').toLowerCase().search(this.search.toLowerCase()) > -1 : true
        })

        if (this.value) {
          const tIndex = options.findIndex((x) => (x[this.val] || x['value']) === this.value)
          if (tIndex > -1) {
            options = this.array_move(options, tIndex, 0)
          }
        }
      }

      if (this.value) {
        const tIndex = options.findIndex((x) => (x[this.val] || x['value']) === this.value)
        if (tIndex > -1) {
          options = this.array_move(options, tIndex, 0)
        }
      }

      return options
    },

    array_move() {
      return (arr, old_index, new_index) => {
        if (new_index >= arr.length) {
          let k = new_index - arr.length + 1
          while (k--) {
            arr.push(undefined)
          }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
        return arr
      }
    }
  },

  methods: {
    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    formatUserSelectLabel(item) {
      if (!item) return ''
      const fullName = `${item.first_name || ''} ${item.last_name || ''}`.trim() || item.label || 'Unknown user'
      if (!item.handle_name) return fullName
      const handle = item.handle_name.startsWith('@') ? item.handle_name : `@${item.handle_name}`
      if (fullName.includes(handle)) return fullName
      return `${fullName} (${handle})`
    },
    getSelectItemText(item) {
      const fullName = `${item.first_name || ''} ${item.last_name || ''}`.trim() || item.label || 'Unknown user'
      const handle = item.handle_name
        ? (item.handle_name.startsWith('@') ? item.handle_name : `@${item.handle_name}`)
        : ''
      return `<div class="select-item-content">
    <div class="user-info">
      <span class="user-name">${this.escapeHtml(fullName)}</span>
      <span class="user-handle">${this.escapeHtml(handle)}</span>
    </div>
    <img src="${this.escapeHtml(item.avatar || '')}" alt="avatar" class="user-avatar" />
  </div>`
    },
    async handleScrollEnd() {
      this.$emit('scrollEnd')
      if (this.ssr && this.action && this.processing === false && !this.nodata) {
        this.page += 1
        await this.getOptions(false)
      }
    },

    async getOptions(apiStat = true) {
      const payload = {
        search: this.search,
        page: this.page,
        limit: this.limit,
        type: this.type,
        ...this.params
      }

      if (this.action && this.viewRendered) {
        this.processing = true

        this.$store
          .dispatch(this.action, payload)
          .then((response) => {
            if (apiStat) {
              this.sso = []
            }

            this.nodata = response.data.length < 1
            this.sso.push(...response.data)
          })
          .catch(() => {})
          .finally(() => {
            this.processing = false
          })
      }
    },

    inputChanged(e) {
      this.search = e.target.value
      this.page = 1
      this.$emit('search', e.target.value || '')
      this.getOptions()
    },

    clearVal() {
      this.inputVal = this.multiple ? [] : null
      this.search = null
      this.page = 1
      this.getOptions()
    }
  },

  watch: {
    action() {
      this.getOptions()
    },

    viewRendered() {
      this.getOptions()
    }
  }
}
</script>

<style lang="scss">
.select-item-with-avatar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;

  .vs-select--item {
    border: none !important;
  }

  .select-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .user-avatar {
    width: 15%;
    height: 15%;
    border-radius: 50%;
    margin-left: 15px; // Adds space between avatar and content
  }

  .user-name {
    font-weight: bold;
    font-size: 1rem;
    color: inherit;
  }

  .user-handle {
    font-size: 0.85rem;
    color: #4b5563;
    margin-top: 2px;
  }

  .user-contact {
    font-size: 0.85rem;
    color: #777;
    margin-top: 2px;
  }
}

.theme-dark .user-handle {
  color: #d1d5db;
}
</style>
